import Link from 'next/link';
import React, { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

import Popover, { PopoverProps } from '../../__temp__design_system/atoms/Popover/Popover';

export interface SignUpForFeaturePopoverProps extends PopoverProps {
    onButtonClick?: () => void;
    buttonText?: string;
    loginRedirect?: string;
    postSignUpUrl: string;
    tagLine: string;
}

const SignUpForFeaturePopover = forwardRef<HTMLButtonElement, SignUpForFeaturePopoverProps>(
    (
        {
            buttonText = 'Create a free account',
            onButtonClick,
            postSignUpUrl,
            tagLine,
            loginRedirect = '',
            className = '',
            ...popoverProps
        },
        ref,
    ) => {
        const getFormSignUpUrl = () => {
            return '/sign-up?redirectAfterRegister=' + postSignUpUrl;
        };
        return (
            <Popover
                className={twMerge('w-64 rounded-xl opacity-100 focus:outline-hidden', className)}
                ref={ref}
                {...popoverProps}
            >
                <div className="text-center font-semibold p-5">
                    <h5 className="my-0 mx-auto text-xs">{tagLine}</h5>

                    <Link
                        className="block focus:outline-hidden focus-visible:ring focus-visible:ring-opacity/20 disabled:text-gray-500 border-2 border-transparent border-solid transition-colors hover:no-underline disabled:bg-gray-200 hover:bg-yellow-600 focus:bg-yellow-600 focus-visible:ring-yellow-400 text-sm bg-yellow-400 text-gray-900 my-4 rounded-sm px-6 py-2"
                        href={getFormSignUpUrl()}
                        onClick={onButtonClick}
                    >
                        {buttonText}
                    </Link>

                    <p className="text-xs m-0">
                        Already a member?{' '}
                        <Link className="text-blue-700" href={loginRedirect}>
                            Log In
                        </Link>
                    </p>
                </div>
            </Popover>
        );
    },
);

export default SignUpForFeaturePopover;
SignUpForFeaturePopover.displayName = 'SignUpForFeaturePopover';
